import React, { useContext, useEffect } from "react"
import { POSContext } from "src/main/PointOfSale/Layout"

import { PaymentFlowContext } from "../../PaymentModal"

const ConfirmationScreenDetails = () => {
  const {
    checkoutDetails: { paymentMethod, setPaymentMethod },
  } = useContext(PaymentFlowContext)
  const { dockwaPayPaymentMethod } = useContext(POSContext)

  useEffect(() => {
    setPaymentMethod({
      paymentMethod: dockwaPayPaymentMethod,
    })
  }, [dockwaPayPaymentMethod, setPaymentMethod])

  return (
    <div className="flex justify-between">
      <span>Payment method:</span>
      <span>{paymentMethod?.paymentMethod.title}</span>
    </div>
  )
}

ConfirmationScreenDetails.confirmButtonLabel = "Process Payment"
ConfirmationScreenDetails.disableCancelButton = false

export default ConfirmationScreenDetails
